import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MyHiringReferralsPage from './pages/MyHiringReferralsPage';
import MyHiringReferralsDetailPage from './pages/MyHiringReferralsDetailPage';

const MyHiringReferralsModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MyHiringReferralsPage />} />
      <Route path="/:applicationId" element={<MyHiringReferralsDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MyHiringReferralsModule;
